export default __webpack_public_path__ + "static/media/svg404.4663b942.webp";